export * as accounts from "./accounts";
export * as address from "./address";
export * as bank from "./bank";
export * as bid from "./bid";
export * as brand from "./brand";
export * as businessTypes from "./business-types";
export * as businessVerticals from "./business-verticals";
export * as category from "./category";
export * as city from "./city";
export * as creditNote from "./credit-note";
export * as creditRating from "./credit-rating";
export * as customerPayment from "./customer-payment";
export * as deal from "./deal";
export * as dealSetting from "./deal-setting";
export * as debitNote from "./debit-note";
export * as dispatch from "./dispatch";
export * as documentMaster from "./document-master";
export * as ewb from "./ewb";
export * as externalBanks from "./external-bank-api";
export * as file from "./file";
export * as invoice from "./invoice";
export * as ledgers from "./ledgers";
export * as note from "./note";
export * as notification from "./notification";
export * as paymentRequest from "./payment-request";
export * as paymentMade from "./payment-made";
export * as paymentTerms from "./payment-terms";
export * as PdfTemplates from "./pdf-template";
export * as pod from "./pod";
export * as product from "./product";
export * as purchaseBill from "./purchase-bill";
export * as purchaseOrder from "./purchase-order";
export * as qualityCheck from "./quality-check";
export * as receivables from "./receivable";
export * as rfq from "./rfq";
export * as state from "./state";
export * as status from "./status";
export * as tax from "./tax";
export * as tradeName from "./trade-name";
export * as uom from "./uom";
export * as user from "./user";
export * as gstSlabs from "./gst-slabs";
